import { QueryParamValueProps, useQueryParamsHandler } from 'odfjell-query-manager';

export const PRODUCT_PARAMS = {
    PRODUCT_ID: 'productId',
    TAB: 'tab',
};

export default () => {
    const { triggerQueryParamsUpdate } = useQueryParamsHandler();

    const setQueryParamProductId = (productId: string) => {
        if (productId) {
            const queryParamValues: QueryParamValueProps[] = [];
            queryParamValues.push({ name: PRODUCT_PARAMS.PRODUCT_ID, newValue: productId });
            triggerQueryParamsUpdate(queryParamValues, 'clear-all');
        }
    };

    const clearQueryParamProductId = () => {
        const queryParamValues: QueryParamValueProps[] = [];
        queryParamValues.push({ name: PRODUCT_PARAMS.PRODUCT_ID, clearParam: true });
        triggerQueryParamsUpdate(queryParamValues, 'clear-all');
    };

    return {
        setQueryParamProductId,
        clearQueryParamProductId,
        PRODUCT_PARAMS,
    };
};
